import tl from '@/internationalization/trans/chefs/tl/tl.json';
export default {
  trans: tl,
};
